import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7706f778"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left" }
const _hoisted_2 = { class: "row items-center" }
const _hoisted_3 = { class: "row-label" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "search-block" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "row-label" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = {
  key: 1,
  class: "value"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "row-label" }
const _hoisted_13 = { class: "value phone" }
const _hoisted_14 = { class: "phoneInfo" }
const _hoisted_15 = {
  key: 0,
  class: "value phone-code"
}
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "row-label" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "row-label" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "row-label" }
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "row-label" }
const _hoisted_28 = { class: "value order-info" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { key: 3 }
const _hoisted_34 = {
  key: 0,
  class: "row"
}
const _hoisted_35 = { class: "row-label" }
const _hoisted_36 = { class: "value" }
const _hoisted_37 = {
  key: 1,
  class: "row"
}
const _hoisted_38 = { class: "row-label" }
const _hoisted_39 = { class: "value" }
const _hoisted_40 = {
  key: 2,
  class: "row"
}
const _hoisted_41 = { class: "row-label" }
const _hoisted_42 = { class: "value" }
const _hoisted_43 = {
  key: 3,
  class: "row"
}
const _hoisted_44 = { class: "row-label" }
const _hoisted_45 = { class: "value" }
const _hoisted_46 = {
  key: 4,
  class: "row"
}
const _hoisted_47 = { class: "row-label" }
const _hoisted_48 = { class: "value" }
const _hoisted_49 = { class: "right" }
const _hoisted_50 = { class: "rows" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "row-label" }
const _hoisted_53 = { class: "value" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "row items-center" }
const _hoisted_57 = { class: "row-label" }
const _hoisted_58 = { class: "value time-set" }
const _hoisted_59 = {
  key: 0,
  class: "map"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonBase = _resolveComponent("ButtonBase")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_RoutePlannerMap = _resolveComponent("RoutePlannerMap")!
  const _component_TimeModal = _resolveComponent("TimeModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "tab-content info",
      ref: _ctx.scrollAreaRef()
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.translate("name")) + ":", 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                (_ctx.order.address.first_name)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.order.address.first_name) + " " + _toDisplayString(_ctx.order.address.last_name), 1)
                    ], 64))
                  : (_ctx.order.address.last_name)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.order.address.last_name), 1)
                      ], 64))
                    : (_ctx.order.address.company)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(_ctx.order.address.company), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                (_ctx.order.is_new_customer)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode(" (" + _toDisplayString(_ctx.translate("new_customer")) + ") ", 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createTextVNode("-")
                    ], 64))
              ]),
              (_ctx.order.customer_id || _ctx.order.company)
                ? (_openBlock(), _createBlock(_component_ButtonBase, {
                    key: 0,
                    type: "secondary",
                    icon: "search",
                    class: "search",
                    onClick: _ctx.openCustomerPage
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.translate("address")) + ":", 1),
          (_ctx.order.address)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "value address",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyAddress()))
              }, [
                _createTextVNode(_toDisplayString(_ctx.order.address.street) + " " + _toDisplayString(_ctx.order.address.street_number) + " ", 1),
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(_ctx.order.address.zipcode) + " " + _toDisplayString(_ctx.order.address.city), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, "-"))
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.translate("phone")) + ":", 1),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, [
              _createTextVNode(_toDisplayString(_ctx.order.phone || "-") + " ", 1),
              (_ctx.order.phone && _ctx.callsEnabled)
                ? (_openBlock(), _createBlock(_component_ButtonBase, {
                    key: 0,
                    class: "click2dial",
                    icon: "phone",
                    type: "primary",
                    onClick: _ctx.makeCall
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.order.address.phone_code)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, " (code: " + _toDisplayString(_ctx.order.address.phone_code) + ") ", 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.translate("email")) + ":", 1),
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.order.email || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.translate("order_placed_with")) + ": ", 1),
          _createElementVNode("div", _hoisted_21, [
            _createTextVNode(_toDisplayString(_ctx.order.source.name) + " ", 1),
            (_ctx.order.source.id)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, "(" + _toDisplayString(_ctx.order.source.id) + ")", 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.translate("order_placed_at")) + ":", 1),
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.formatDateTime(_ctx.order.created_at)), 1)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.translate("order")) + ":", 1),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.translate("total")) + " ", 1),
              _createElementVNode("b", null, _toDisplayString(_ctx.useFormatCurrency(_ctx.order.total)) + " ", 1)
            ]),
            (_ctx.order.delivery_costs)
              ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                  _createTextVNode(_toDisplayString(_ctx.translate("delivery_costs")) + " ", 1),
                  _createElementVNode("b", null, _toDisplayString(_ctx.useFormatCurrency(_ctx.order.delivery_costs)) + " ", 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createTextVNode(" ("),
              (_ctx.order.payment?.method)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.order.payment.method_name) + ", ", 1))
                : _createCommentVNode("", true),
              (_ctx.order.payment2?.method)
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.order.payment2.method_name) + ", ", 1))
                : _createCommentVNode("", true),
              (_ctx.order.payment?.status)
                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.isActuallyPaid(_ctx.order) || _ctx.isPinFinal(_ctx.order)
                                    ? _ctx.order.payment.status_name
                                    : _ctx.translate("unpaid")), 1))
                : _createCommentVNode("", true),
              _createTextVNode(") "),
              (_ctx.isCashOrder && _ctx.order.payment.option)
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                    _createTextVNode(" - " + _toDisplayString(_ctx.translate("customer_pays_with")) + " ", 1),
                    _createElementVNode("b", null, _toDisplayString(_ctx.order.payment.option === "exact"
                                    ? _ctx.useFormatCurrency(_ctx.order.total)
                                    : _ctx.useFormatCurrency(
                                          Number(_ctx.order.payment.option)
                                      )), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.paymentMethodsEditable)
              ? (_openBlock(), _createBlock(_component_SelectComponent, {
                  key: 1,
                  name: "payment-options",
                  options: _ctx.paymentMethodOptions,
                  value: _ctx.order.payment?.method,
                  "onUpdate:value": _ctx.updatePayment
                }, null, 8, ["options", "value", "onUpdate:value"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.order.discount?.amount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.translate("discount")) + ":", 1),
              _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.useFormatCurrency(_ctx.order.discount.amount)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.order.discount?.code)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.translate("promo_code")) + ":", 1),
              _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.order.discount.code), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.order.points.paid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.translate("points_paid")) + ":", 1),
              _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.order.points.paid || 0), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.order.tip > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.translate("tip")) + ":", 1),
              _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.order.tip ? _ctx.useFormatCurrency(_ctx.order.tip) : "-"), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.order.customer && _ctx.order.customer.notes)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.translate("notes")) + ":", 1),
              _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.order.customer.notes), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.translate("requested_time")) + ": ", 1),
            _createElementVNode("div", _hoisted_53, [
              (_ctx.order.time === 'asap')
                ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_ctx.translate("asap")), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.order.time || "-"), 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.translate("estimated_time")) + ": ", 1),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("span", null, _toDisplayString(_ctx.timeSetLabel), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.distanceDurationLabel) + " ", 1),
              _createVNode(_component_ButtonBase, {
                onClick: _ctx.toggleModal,
                type: "warning"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("change")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        (_ctx.order.coordinates)
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              _createVNode(_component_RoutePlannerMap, {
                origin: 
                        _ctx.multiLocation.isActive
                            ? _ctx.multiLocation.location(_ctx.order.client_id)
                                  ?.coordinates
                            : _ctx.userStore.user.coordinates
                    ,
                destination: _ctx.order.coordinates,
                deliverer: _ctx.order.deliverer,
                mode: _ctx.settingStore.settings.google_directions_mode
              }, null, 8, ["origin", "destination", "deliverer", "mode"])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 512),
    _createVNode(_component_TimeModal, {
      show: _ctx.isModalOpened,
      onClose: _ctx.toggleModal,
      "order-time": _ctx.order.time_set,
      "onUpdate:time": _ctx.updateTime,
      "sms-disabled": !_ctx.order.phone || _ctx.smsDisabled,
      "email-disabled": !_ctx.order.email
    }, null, 8, ["show", "onClose", "order-time", "onUpdate:time", "sms-disabled", "email-disabled"])
  ], 64))
}